import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import OnsVerhaal from "./sections/OnsVerhaal";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <OnsVerhaal />
      <Footer />
    </div>;
}